module.exports = __webpack_public_path__ + "img/somalia.6880c080.svg";